/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		height: '100%',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-end',
	},
	greetingsContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: token('space.200'),
		marginBottom: token('space.200'),
	},
	actionsContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: token('space.100'),
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
	},
});

interface Props {
	testId?: string;
	showGreeting?: boolean;
	showActions?: boolean;
	actionSize?: number;
}

export const RovoEmptyStateLoading = (props: Props): JSX.Element => {
	const { testId, showActions = true, showGreeting = true, actionSize = 3 } = props;

	return (
		<Inline testId={testId} alignBlock="center" alignInline="center" xcss={styles.container}>
			{showGreeting && (
				<Box xcss={styles.greetingsContainer}>
					<Skeleton isShimmering width="306px" height="120px" />
				</Box>
			)}
			{showActions && (
				<Box xcss={styles.actionsContainer}>
					{Array.from({ length: actionSize }).map((_, index) => (
						<Skeleton key={index} isShimmering width="100%" height="32px" />
					))}
				</Box>
			)}
		</Inline>
	);
};
